import { ExportButtonDropdown, ExportType } from '@components'

import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useExportContacts } from '@features/contacts/hooks/useExportContacts'

import { ExportsCard } from '../ExportsCard'

export const Contacts = () => {
  const { t } = useTranslation()
  const { exportContacts } = useExportContacts()

  const handleSelect = useCallback(
    (_: string, type: ExportType) => {
      exportContacts(type === ExportType.Xlsx ? ExportType.Xlsx : ExportType.Csv)
    },
    [exportContacts],
  )

  return (
    <ExportsCard
      description={t('exports.card.contacts.description')}
      title={t('exports.card.contacts.title')}
      actionButton={
        <ExportButtonDropdown
          exportTypesToSkip={[ExportType.RegnskabBasis, ExportType.Html, ExportType.Pdf]}
          onSelect={handleSelect}
          variant="outlined"
          fullWidth
        />
      }
    />
  )
}
